<script setup lang="ts">
interface Props {
  regionCode: string;
  regionName: string;
  loading: boolean;
}

defineProps<Props>();
</script>

<template>
  <header class="mb-8">
    <template v-if="loading">
      <div class="flex items-center gap-4 mb-4">
        <div class="w-12 h-12 rounded-md bg-white/10 animate-pulse" />
        <div
          class="h-10 bg-white/10 animate-pulse rounded-md flex-1 max-w-xs"
        />
      </div>
      <div class="h-6 bg-white/5 animate-pulse rounded-md mb-8" />
      <div class="h-6 bg-white/10 animate-pulse rounded-md max-w-[200px]" />
    </template>

    <template v-else>
      <div class="flex items-center gap-4 mb-4">
        <img
          v-if="!regionCode.includes('-')"
          :src="`https://flagcdn.com/${regionCode.toLowerCase()}.svg`"
          :alt="regionCode"
          class="w-12 h-12 rounded-md object-cover shadow-sm"
          width="48"
          height="48"
        />
        <h1 class="text-3xl lg:text-4xl font-bold text-white">
          {{ regionName }} eSIMs
        </h1>
      </div>

      <p class="text-lg text-muted-foreground mb-8">
        Get an eSIM for {{ regionName }} and enjoy reliable and affordable
        internet access on your trip.
      </p>

      <h2 class="text-xl font-semibold text-white">Choose your data plan</h2>
    </template>
  </header>
</template>
